module.exports = __webpack_public_path__ + "media/images/ui__arrowUp-9a5ac9dfe2bbfefaca858a4c948e2dea.png";